export default __webpack_public_path__ + "static/media/vendor2.52176952.png";